module.exports = __webpack_public_path__ + "img/deposit.84bc09b8.svg";